import { TPublicUser } from 'types/publicUser';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function publicUser(state: any = {}, action: any): TPublicUser {
  return state;
}
